import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CardModule,
        ButtonModule,
        MessageModule
    ],
    selector: 'app-contracting-not-found',
    templateUrl: './contracting-not-found.component.html',
    styles: []
})
export class ContractingNotFoundComponent {
goToLuxoro() {
  window.open('https://luxoro.es')
}
}
